/* Store Ec · X13 — utilidades compartidas: aparición suave y compra rápida */
(function(){
  document.documentElement.classList.add('x13-js');
  function aparecer(){
    var els=document.querySelectorAll('[data-x13-aparece]:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(ents){ents.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target)}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  // red de seguridad: nada queda oculto aunque falle el observador
  setTimeout(function(){document.querySelectorAll('[data-x13-aparece]').forEach(function(e){e.classList.add('is-in')})},2500);
  document.addEventListener('DOMContentLoaded',aparecer);
  document.addEventListener('shopify:section:load',aparecer);

  window.X13=window.X13||{};

  // Agrega al carrito SOLO por AJAX con X13T.agregar (x13-tienda.js): sin /cart/add.js, sin cajón y sin salir de la página.
  // Si x13-tienda.js todavía no cargó, espera hasta 5 s y, si no aparece, lo carga.
  function conTienda(fn){
    if(window.X13T&&window.X13T.agregar){fn();return}
    var t0=Date.now(),cargado=false;
    (function esperar(){
      if(window.X13T&&window.X13T.agregar){fn();return}
      if(!cargado&&Date.now()-t0>1500){
        cargado=true;
        var actual=document.querySelector('script[src*="x13.js"]');
        if(actual&&!document.querySelector('script[src*="x13-tienda.js"]')){var s=document.createElement('script');s.src=actual.src.replace('x13.js','x13-tienda.js');document.head.appendChild(s)}
      }
      if(Date.now()-t0>5000)return;
      setTimeout(esperar,100);
    })();
  }
  window.X13.comprar=function(variantId,cantidad,boton){
    conTienda(function(){window.X13T.agregar([{id:Number(variantId),quantity:Number(cantidad)||1}],boton)});
  };

  // Cambia la cantidad de una línea del carrito (venta adicional del carrito)
  window.X13.cambiarCantidad=function(variantId,cantidad){
    var u={};u[variantId]=cantidad;
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:u})})
      .then(function(){window.location.reload()});
  };

})();
